module.exports = __webpack_public_path__ + "static/media/bg-dog.d4c14a83.png";